import { Skeleton } from 'antd';

/**
 * Settings tab skeleton — multiple section cards.
 */
export default function SettingsSkeleton() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }} className="bl-animate-in">
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          style={{
            borderRadius: 16,
            background: 'var(--bl-surface, #fff)',
            border: '1px solid var(--bl-divider, #ebebeb)',
            padding: '14px',
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          {/* Section header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Skeleton.Avatar active size={28} shape="square" style={{ borderRadius: 9 }} />
            <Skeleton.Input active size="small" style={{ width: 120, height: 14 }} />
          </div>
          {/* Section content */}
          <Skeleton active paragraph={{ rows: 1 }} title={{ width: '80%' }} />
        </div>
      ))}
    </div>
  );
}
